var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3334 17.1788L8.87461 23.6376C8.63295 23.8793 8.32539 24.0001 7.95192 24.0001C7.57845 24.0001 7.27089 23.8793 7.02923 23.6376C6.78758 23.3959 6.66675 23.0884 6.66675 22.7149C6.66675 22.3414 6.78758 22.0339 7.02923 21.7922L13.488 15.3334L7.02923 8.87461C6.78758 8.63295 6.66675 8.32539 6.66675 7.95192C6.66675 7.57845 6.78758 7.27089 7.02923 7.02923C7.27089 6.78758 7.57845 6.66675 7.95192 6.66675C8.32539 6.66675 8.63295 6.78758 8.87461 7.02923L15.3334 13.488L21.7922 7.02923C22.0339 6.78758 22.3414 6.66675 22.7149 6.66675C23.0884 6.66675 23.3959 6.78758 23.6376 7.02923C23.8793 7.27089 24.0001 7.57845 24.0001 7.95192C24.0001 8.32539 23.8793 8.63295 23.6376 8.87461L17.1788 15.3334L23.6376 21.7922C23.8793 22.0339 24.0001 22.3414 24.0001 22.7149C24.0001 23.0884 23.8793 23.3959 23.6376 23.6376C23.3959 23.8793 23.0884 24.0001 22.7149 24.0001C22.3414 24.0001 22.0339 23.8793 21.7922 23.6376L15.3334 17.1788Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d1739f073156cef1e28cc9e26320682e.svg";
export { ForwardRef as ReactComponent };